import React, {Component} from 'react'
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import {fetchAfiliate} from "../../reducers/customer/customerActions";
import {connect} from "react-redux";
import {fetchAffiliate} from "../../reducers/affiliate/affiliateActions";

class AffiliateTypeahead extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allowNew: false,
            isLoading: false,
            multiple: false,
            useCache: false
        };
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    clearText() {
        this.refs.syncTypeAhead.getInstance().clear();
    }

    handleSearch = (query) => {
        this.setState({ isLoading: true });
        let promise = new Promise((resolve, reject) => { this.props.fetchAffiliate(query, resolve, reject);});
        promise.then(() => { this.setState({ isLoading: false }); });
    }

    handleChange(affiliateSelected) {
        if (affiliateSelected === undefined) {
            affiliateSelected = null;
        }
        this.props.onAffiliateChange(affiliateSelected);
    }

    render() {
        console.log("this.props.affiliates", this.props.affiliates);
        return (
            <AsyncTypeahead
                {...this.state}
                ref="syncTypeAhead"
                options={this.props.affiliates}
                labelKey="completeName"
                minLength={3}
                onSearch={this.handleSearch}
                placeholder="Seleccionar Afiliado"
                defaultValue="Search..."
                onChange={(selected) => this.handleChange(selected[0])}
                renderMenuItemChildren={(option, props) => (
                    <div key={option.id}> {option.completeName}  </div>
                )}
            />
        )
    }
}

const mapStateToProps = state => ({ affiliates: state.affiliate.items });
export default connect(mapStateToProps, { fetchAffiliate })(AffiliateTypeahead)



// WEBPACK FOOTER //
// ./src/components/Typeaheads/AffiliateTypeahead.jsx